import { render, staticRenderFns } from "./ComplianceCard.vue?vue&type=template&id=03841088"
import script from "./ComplianceCard.vue?vue&type=script&lang=js"
export * from "./ComplianceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports